import { BaseElement, defineElement } from "./lib-element-js.min.js";

class CssSlider extends BaseElement {
  container = this.querySelector("ul");
  scrollbar = this.querySelector(".css-slider-scrollbar");
  scrollbarHandle = this.querySelector(".css-slider-scrollbar--bar");

  // lifecycle hook
  connected() {
    const scrollbarWidth =
      (this.container.offsetWidth / this.container.scrollWidth) * 100;

    if (scrollbarWidth >= 95) {
      this.scrollbar.style.display = "none";
      this.querySelector(".last-item").style.display = "none";
    }

    this.scrollbarHandle.style.width = `${scrollbarWidth}%`;
    this.container.onscroll = () => {
      this.scrollbarHandle.style.left = `${
        (this.container.scrollLeft / this.container.offsetWidth) *
        ((this.container.offsetWidth / this.container.scrollWidth) * 100)
      }%`;
    };
  }

  // reactive attributes/properties
  // properties() {
  //   return {
  //     loaded: false,
  //   };
  // }
}
defineElement("css-slider", CssSlider);
